import DetailSPKPermintaanPrelim from './DetailSPKPermintaanPrelim';

export default DetailSPKPermintaanPrelim;
